// Modules
import initCookieConsent from './modules/cookie-consent';
import addWindowScrollPositionToDocument from './modules/viewport';
import initMenuToggle from './modules/menu-toggle';
import initCounters from './modules/counters';
import initLottie from './modules/lottie';
import carousels from './modules/carousels';

addWindowScrollPositionToDocument();
carousels.inspirationSlider();

try {
    // Libaries
    window.$ = window.jQuery = require('jquery');

    // Functions
    require('./functions/isOnScreen');
} catch (e) {
}

const $document = $(document);

$document.ready(() => {
    initLottie();
    initMenuToggle();
    initCounters();
    initCookieConsent();
});
